// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getShipmentAuditEvents } from '@/audit/api/get-shipment-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { Stack, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  shipmentKey: string;
}

/**
 * Suspends while fetching the audit events for a single shipment and renders
 * them in reverse chronological order using the shared AuditEventListItem.
 */
export function ShipmentAuditList(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: ['shipment', props.shipmentKey, 'audit'],
    queryFn: () => getShipmentAuditEvents(props.shipmentKey),
    retry: false,
  });

  if (data.events.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No audit events recorded for this shipment yet
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
